const getState = state => state.featureFlags

export const getEnableUpgradeToPro = state => getState(state).enableUpgradeToPro
export const getAutoCallIntoMeeting = state => getState(state).autoCallIntoMeeting
